<template>
  <el-dialog title="信息上报" :visible.sync="visible" width="500px" @close="$emit('update:show', false)" append-to-body
    :close-on-click-modal="false">
    <el-form v-if="model" ref="form" label-width="80px" :model="model" :rules="formRules">
      <!-- <el-form-item label="客户名称" prop="customer_name" v-if="!inner">
        <el-input size="small" v-model="model.customer_name" placeholder="客户名称"></el-input>
      </el-form-item> -->
      <el-form-item label="客户名称" prop="customer_id" v-if="!inner">
        <customer-select :val="model.customer_id" @change="model.customer_id = $event"></customer-select>
      </el-form-item>
      <el-form-item label="描述" prop="desc">
        <el-input size="small" v-model="model.desc" type="textarea" placeholder="上报描述"></el-input>
      </el-form-item>
      <el-form-item label="商机类型" prop="business_opportunity_type">
        <BusinessOpportunitySelector v-model="model.business_opportunity_type"></BusinessOpportunitySelector>
      </el-form-item>
      <el-form-item label="图片" prop="name_plate">
        <div>
          <viewer class="viewer" ref="viewer">
            <div v-for="(pic, index) in model.imgs" :key="index" class="flex-row-between">
              <auth-img tag="el-image" style="width: 50px; height: 50px; margin-bottom: 5px" :src="pic"
                :preview-src-list="model.imgs" />
              <el-button size="mini" type="text" icon="el-icon-close" @click="handleRemove(index)">删除</el-button>
            </div>
          </viewer>
        </div>
        <el-upload class="avatar-uploader" :action="uploadUrl" :limit="20" multiple accept="image/*" ref="uploader"
          :show-file-list="false" :headers="uploadHeader" :on-success="handleSuccess" :on-error="handleUploadError"
          :before-upload="beforeUpload">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" :loading="submiting" @click="submitForm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { urlPerfix } from '@/config/env'
import { createCustomerIssue, updateCustomerIssue } from '../service/getData'
import store from '@/store/store'
import CustomerSelect from '@/components/select/customer_select'

export default {
  components: {
    CustomerSelect
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    inner: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    model() { },
  },
  data() {
    return {
      uploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      formRules: {
        customer_name: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
        ],
        customer_id: [
          { required: true, message: '请选择客户', trigger: 'change' },
          { type: 'number', min: 1, message: '请选择客户' },
        ],
        desc: [
          { required: true, message: '请输入信息描述', trigger: 'blur' },
          {
            min: 1,
            max: 500,
            message: '长度在 1 到 500 个字符',
            trigger: 'blur',
          },
        ],
      },
      submiting: false,
    }
  },
  created() { },

  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          if (this.model.id > 0) {
            let res = await updateCustomerIssue(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createCustomerIssue(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          console.log('error submit!!')
        }
      })
    },
    handleSuccess(res, file) {
      if (res.code == 0) {
        this.model.imgs.push(res.data)
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 < this.uploadLimitSize.image
      if (!isLimitSize) {
        this.$message.error(`文件大小不能超过 ${this.uploadLimitSize.image}MB!`)
      }
      return isLimitSize
    },
    handleRemove(index) {
      this.model.imgs.splice(index, 1)
    },
  },
}
</script>